import React, { useState } from 'react';

import { PlusCircleFilled } from '@ant-design/icons';
import { Space, Row, Col, Button, Input, Drawer } from 'antd';

import stringres from '../../translations/stringres';
import MenuMain from '../MainMenu';
import OpportunitaGrid from './OpportunitaGrid';
import OpportunitaScheda from './OpportunitaScheda';

const { Search } = Input;

export default function OpportunitaElenco() {
    const [refresh, setRefresh] = useState(false);
    const [filtro, SetFiltro] = useState(null);
    const [open, setOpen] = useState(false);

    function onClickNew() {
        setOpen(true);
    }

    function onSearch(value) {
        SetFiltro(value);
        setRefresh(!refresh);
    }

    return (
        <div>
            <MenuMain currentMenu="opportunita"></MenuMain>
            <Row align={'middle'} justify={'start'} className="Space-horizontal">
                <Col className="Col-Separator">
                    <label className="App-title">{stringres.t('elencoopportunita')}</label>
                </Col>
                <Col className="Col-Separator">
                    <Button icon={<PlusCircleFilled />} onClick={onClickNew} type="primary">
                        {stringres.t('nuovo')}
                    </Button>
                </Col>
                <Col className="Col-Separator" span={8}>
                    <Search
                        placeholder={stringres.t('campodiricercaopportunita')}
                        allowClear
                        enterButton={stringres.t('ricerca')}
                        size="large"
                        onSearch={onSearch}
                    />
                </Col>
            </Row>
            <Space className="App-body" direction="vertical">
                <OpportunitaGrid refresh={refresh} filtro={filtro}></OpportunitaGrid>
            </Space>
            <Drawer
                open={open}
                title={stringres.t('opportunita')}
                onClose={() => setOpen(false)}
                style={{ backgroundColor: '#eef2f4' }}
                width={'90%'}
            >
                <OpportunitaScheda></OpportunitaScheda>
            </Drawer>
        </div>
    );
}
